import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

export const useCartesAruco = (refresh) => {
  return useApi(`${url}cartes-aruco/`, [], refresh);
};
